/* eslint-disable no-const-assign */
import Cookies from 'js-cookie'

const TokenKey = 'jy_token'
const ALL_NUMBERS = '0123456789'
var Qs = require('qs')

export default {

  paramsSerializer(params) {
    return Qs.stringify(params, { arrayFormat: 'repeat' })
  },

  randNNumber(n) {
    let s = ''
    for (let i = 0; i < n; i++) {
      const r = Math.floor(Math.random() * 10)
      s = s + ALL_NUMBERS.charAt(r);
    }
    return s;
  },

  formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
  },

  formatYear(date) {
    if (date == null) {
      return
    }
    if (Object.prototype.toString.call(date) === '[object String]') {
      return date.split(' ')[0]
    }
    const year = date.getFullYear()
    return year
  },

  formatDate(date) {
    if (date == null) {
      return
    }
    if (Object.prototype.toString.call(date) === '[object String]') {
      return date.split(' ')[0]
    }
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()

    return [year, month, day].map(this.formatNumber).join('-')
  },

  formatDateYM(date) {
    if (date == null) {
      return
    }
    if (Object.prototype.toString.call(date) === '[object String]') {
      return date.split(' ')[0]
    }
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const data = year + "" + month
    if (data.length === 5) {
      return year + "0" + month
    } else {
      return data
    }
  },

  formatDateMD(date) {
    if (date == null) {
      return
    }
    if (Object.prototype.toString.call(date) === '[object String]') {
      return date.split(' ')[0].slice(5)
    }
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()

    return [month, day].map(this.formatNumber).join('-')
  },

  formatTime(date) {
    const hour = date.getHours()
    const minute = date.getMinutes()
    return [hour, minute].map(this.formatNumber).join(':')
  },


  formatTimeHMS(date) {
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    return [hour, minute, second].map(this.formatNumber).join(':')
  },
  formatDateTime(date) {
    return this.formatDate(date) + ' ' + this.formatTime(date)
  },

  formatDateTimeYMDHMS(date) {
    return this.formatDate(date) + ' ' + this.formatTimeHMS(date)
  },

  beginOfDay(date) {
    const d = new Date(date)
    d.setHours(0, 0, 0)
    return d
  },

  endOfDay(date) {
    const e = new Date(date)
    e.setHours(23, 59, 59)
    return e
  },

  nextNDay(n) {
    const date = new Date()
    date.setDate(date.getDate() + n)
    return date
  },

  beginOfThisWeek() {
    var date = new Date();
    var today = date.getDay();
    var stepSunDay = -today + 1;
    if (today === 0) {
      stepSunDay = -7;
    }
    var time = date.getTime();
    return new Date(time + stepSunDay * 24 * 3600 * 1000);
  },

  endOfThisWeek() {
    var date = new Date();
    var today = date.getDay();
    var stepMonday = 7 - today;
    var time = date.getTime();
    return new Date(time + stepMonday * 24 * 3600 * 1000);
  },

  getCurrentMonthFirst() {
    var date = new Date();
    date.setDate(1);
    var month = parseInt(date.getMonth() + 1);
    var day = date.getDate();
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    return date.getFullYear() + '-' + month + '-' + day;
  },

  getCurrentMonthLast() {
    var date = new Date();
    var currentMonth = date.getMonth();
    var nextMonth = ++currentMonth;
    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    var oneDay = 1000 * 60 * 60 * 24;
    var lastTime = new Date(nextMonthFirstDay - oneDay);
    var month = parseInt(lastTime.getMonth() + 1);
    var day = lastTime.getDate();
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    return date.getFullYear() + '-' + month + '-' + day;
  },


  getMonthLast(year, month) {
    var nextMonthFirstDay = new Date(year, month, 1);
    var oneDay = 1000 * 60 * 60 * 24;
    var lastTime = new Date(nextMonthFirstDay - oneDay);
    var month = parseInt(lastTime.getMonth() + 1);
    var day = lastTime.getDate();
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + month + '-' + day;
  },

  reportStartAt(yearMonth) {
    return yearMonth + '-01 00:00'
  },

  reportEndAt(yearMonth) {
    return this.getMonthLast(
      yearMonth.slice(0, 4),
      yearMonth.slice(5, 7)
    ) + " 23:59";
  },

  monthNumToCN(monthNum) {
    if (monthNum.length == 2 && monthNum.slice(0, 1) == 0) {
      return monthNum.slice(1, 2) + '月'
    }
    return monthNum + '月'
  },


  serialNo() {
    const text = this.formatDate(new Date()).replace(/-/g, "") +
      "0" +
      this.randNNumber(5)
    return text.substring(2, 14)
  },
  serialNoSimple() {
    const text = this.formatDate(new Date()).replace(/-/g, "")
    return text.substring(2, 8)
  },

  formatCurrency(val) {
    if (val === null || val === undefined) {
      return ''
    }
    return '￥' + this.toFixed(val, 2)
  },

  formatCurrency4(val) {
    if (val === null) {
      return ''
    }
    return '￥' + this.toFixed(val, 4)
  },

  toFixed(val, number) {
    if (val === null || val === undefined) {
      return ''
    }
    const initial = parseFloat(val).toFixed(number)
    const r = initial.split('.')[1];
    let tr = '';
    if (r !== undefined) {
      for (let i = r.length - 1; i >= 0; i--) {
        if (r[i] !== '0') {
          tr = r.substring(0, i + 1);
          break;
        }
      }
    }
    if (tr === '') {
      return initial.split('.')[0]
    } else {
      return initial.split('.')[0] + '.' + tr
    }
  },

  param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
      return {}
    }
    return JSON.parse(
      '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
    )
  },

  requestHeader(token = null) {
    const hs = { 'content-type': 'application/json', 'type': 'web' }
    const tk = token || Cookies.get(TokenKey)
    if (tk) {
      hs.token = tk
    }
    return hs
  },

  date(num) {
    var date1 = new Date();
    var date2 = new Date();
    date2.setDate(date1.getDate() + num);
    return (date2.getMonth() + 1) + "-" + date2.getDate();
  },

  dateDiff(sDate1, sDate2) { // sDate1和sDate2是2002-12-18格式
    if (!sDate1 || !sDate2) {
      return ""
    }
    let date1 = Date.parse(this.formatDate(sDate1));
    let date2 = Date.parse(this.formatDate(sDate2));
    let dateSpan = date1 - date2;
    return Math.floor(dateSpan / (24 * 3600 * 1000))
  },

  dateDiff2(sDate1, sDate2) {
    if (sDate1 == null || sDate2 == null) {
      return null;
    } else {
      var date1 = new Date(sDate1.replace(/-/g, "/"));
      var date2 = new Date(sDate2.replace(/-/g, "/"));
      var days = date2.getTime() - date1.getTime();

      var time = parseFloat(days) / 1000; // 先将毫秒转化成秒
      if (time > 60 && time < 60 * 60) {
        time = parseInt(time / 60.0) + "分钟" + parseInt((parseFloat(time / 60.0) -
          parseInt(time / 60.0)) * 60) + "秒";
      } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
        time = parseInt(time / 3600.0) + "小时" +
          parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) + "分钟" +
          parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) - parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
      } else if (time >= 60 * 60 * 24) {
        // console.log("====",parseInt((parseFloat(time / 86400) - parseInt(time / 86400)) * 24))
        time = parseInt(time / 86400.0) + "天" + Math.round((parseFloat(time / 86400.0) - parseInt(time / 86400.0)) * 24) + "小时" +
          parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) + "分钟" +
          parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) - parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
      } else {
        time = parseInt(time) + "秒";
      }
      return time
    }
  },

  dateAddMinute(date, minute) {
    if (date != null) {
      const min = date.getMinutes();
      date.setMinutes(min + minute);
      return date
    }
    return date
  },

  nowAddDay(day) {
    const date = new Date();
    // const today = date.getDay();
    var time = date.getTime();
    return this.formatDate(new Date(time + day * 24 * 3600 * 1000));
  },

  tranJSONArrToString(specJson) {
    const specJsonArr = []
    if (specJson != null && specJson !== '') {
      const arr = JSON.parse(specJson)
      for (const a of arr) {
        specJsonArr.push(a.name + '：' + a.value)
      }
    }
    return specJsonArr.join('；')
  },
  tranJSONArrToStringBr(specJson) {
    const specJsonArr = []
    if (specJson != null && specJson !== '') {
      const arr = JSON.parse(specJson)
      for (const a of arr) {
        specJsonArr.push(a.name + '：' + a.value)
      }
    }
    return specJsonArr.join('<br/>')
  },
  tranJSONArrToArr(JSONArr) {
    return JSONArr ? JSON.parse(JSONArr) : []
  },

  tranStringToArr(str) {
    return str ? str.split(';') : []
  },

  regexPrice(price) {
    if (price == null || price === '') {
      return false
    }
    const p = Number(price)
    const regQtyInt = /^\d+$/;
    const regQtyDouble = /^\d+\.\d+$/
    return regQtyInt.test(p) || regQtyDouble.test(p)
  },
  regexQuantity(quantity) {
    if (quantity == null || quantity === '') {
      return false
    }
    const qty = Number(quantity)
    const regQtyInt = /^\d+$/;
    const regQtyDouble = /^\d+\.\d+$/
    return regQtyInt.test(qty) || regQtyDouble.test(qty)
  },

  intersection(arr1, arr2) {
    if (Object.prototype.toString.call(arr1) === "[object Array]"
      && Object.prototype.toString.call(arr2) === "[object Array]") {
      return arr1.filter(function (v) {
        return arr2.indexOf(v) !== -1
      })
    }
  },
  regexAlphabetNumber(text) {
    return RegExp("^[0-9A-Za-z-]+$").test(text)
  },
  regexAlphabetNumberLine(text) {
    return RegExp("^[0-9A-Za-z-]+$").test(text)
  },
  regexNumber(text) {
    return RegExp("^[0-9]+$").test(text)
  },
  regexPhone(value) {
    if (value != null && value.trim() != '') {
      var phoneReg = /^(((1[3-9]{1}))+\d{9})$/;
      return phoneReg.test(value.trim());
    }
    return false
  },
  // 有效密码需要至少8位，需要大写小写数字特殊字符混合
  regexPassword(value) {
    if (value != null && value.trim() != '') {
      var passwordReg = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!#@*&.])[a-zA-Z\d!#@*&.]*$/;
      return passwordReg.test(value.trim()) && value.length > 7;
    }
    return false
  },

  regexChinese(value) {
    if (value != null && value.trim() != '') {
      let reg = /^[\u4e00-\u9fa5]+$/;
      return reg.test(value.trim())
    }
    return false
  },


  handleNameLen(playerName, len = 10) {
    var new_playerName = "";
    if (playerName.length > len) {
      new_playerName = playerName.substring(0, len);
      new_playerName += "..."
    } else {
      new_playerName = playerName;
    }
    return new_playerName;
  },

  boolean(value) {
    return value ? '是' : '否'
  },

  rawBr(value) {
    if (value == null || value.trim() === '') {
      return null
    }
    return value.replace(/\n/g, '<br/>')
  },


  limitText(value, number, type) {
    if (value != null) {
      const valueLen = value.length
      if (valueLen > number) {
        if (type == 'before') {
          return '..' + value.substring(valueLen - number)
        }
        return value.substring(0, number) + '..'

      }
      return value
    }
    return null
  },
  deleteObjValueIsNull(obj) {
    let params = {}
    for (let key in obj) {
      if (obj[key] && (JSON.stringify(obj[key]) !== '[]')) {
        params[key] = obj[key]
      }
    }

    return params
  },

  toFixed(val, number) {
    if (val === null || val === undefined) {
      return ''
    }
    const initial = parseFloat(val).toFixed(number)
    const r = initial.split('.')[1];
    let tr = '';
    if (r !== undefined) {
      for (let i = r.length - 1; i >= 0; i--) {
        if (r[i] !== '0') {
          tr = r.substring(0, i + 1);
          break;
        }
      }
    }
    if (tr === '') {
      return initial.split('.')[0]
    } else {
      return initial.split('.')[0] + '.' + tr
    }
  },
  jyTrim(x) {
    if (x === '' || x === null || x === undefined) {
      return null;
    }
    const result = x.replace(/^\s+|\s+$/gm, '');
    if (result === '' || result === null || result === undefined) {
      return null;
    }
    return result;
  },
  parseQueryString(url, prop) {
    if (url.split("?").length == 1) {
      return null
    }
    const str = url.split("?")[1]
    const items = str.split("&")
    var arr, name, value;
    for (var i = 0, l = items.length; i < l; i++) {
      arr = items[i].split("=");
      name = arr[0];
      value = arr[1];
      if (name === prop) {
        return value
      }
    }
    return null
  },
  qrcodeAnalysis(str, prop) {
    if (str.indexOf("?") == -1 && str.indexOf("|") == -1) {
      return str;
    }
    if (str.indexOf("|") != -1 && str.split('|').length == 5) {
      return this.parseNewParams(str, prop);
    }
    if (str.indexOf("?") != -1) {
      return this.parseQueryString(str, prop);
    }
    return null;
  },
  parseNewParams(newStr, queryName) {
    // productNo|color|size|type|serialNo
    if (queryName == 'productNo') {
      return newStr.split("|")[0];
    }
    if (queryName == 'color') {
      return newStr.split("|")[1];
    }
    if (queryName == 'size') {
      return newStr.split("|")[2];
    }
    if (queryName == 'type') {
      return newStr.split("|")[3];
    }
    if (queryName == 'serialNo') {
      return newStr.split("|")[4];
    }
  },
  //排序
  objArraySort(objArray, key) {
    let result = objArray.slice(0)
    return result.sort((a, b) => a[key] - b[key])
  },
  objArraySort2(objArray, key) {
    let result = objArray.slice(0)
    return result.sort((a, b) => b[key] - a[key])
  },

}

